import {Component, OnInit} from '@angular/core';
import {InfluencerService} from '../../../services/influencer/influencer.service';
import {InfluencerDetail} from '../../../../models/influencer';
import {MeasureComponent} from '../../measure/measure.component';
import {MeasureService} from '../../../services/measure/measure.service';
import {CampaignService} from '../../../services/campaign/campaign.service';
import {InfluencerGroupsService} from '../../influencer-groups/influencer-groups.service';
import {ReferenceDataService} from '../../../services/reference-data/reference-data.service';
import {TranslateService} from '@ngx-translate/core';
import {UserService} from '../../../services/user.service';
import {ModalService} from '../../../services/modal/modal.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {PdfViewerService} from '../pdf-viewer.service';
import {CommonConstant, chartConfig} from '../../../app.constants';
import {PdfExportService} from '../../../services/export-pdf/pdf-export.service';
import {ReportSectionEnum} from '../../../../models/measure/report';
import {EventTrackerService} from '../../../services/event-tracker/event-tracker.service';
import {DateRange} from '../../../../models/date-range';

declare var require: any;
export enum ServiceCounter {
  init = 0,
  max = 8,
  renderTimeout = 10000
}

@Component({
  selector: 'measure-pdf-viewer',
  templateUrl: './measure-pdf-viewer.component.html',
  styleUrls: ['./measure-pdf-viewer.component.scss']
})

export class MeasurePdfViewerComponent extends MeasureComponent implements OnInit {

  public influencer: InfluencerDetail;
  public currentDate: Date;
  public previousDate: Date;
  private specialReports = [ReportSectionEnum.ROI_REPORT, ReportSectionEnum.OONA_REPORT, ReportSectionEnum.INTERACTION_REPORT, ReportSectionEnum.SEGMENTATION_SEGMENT_REPORT];
  public industryDrillDownReportPieSize = chartConfig.industryDrillDownChart.chartSize;

  constructor(
    measureService: MeasureService,
    campaignService: CampaignService,
    influencerGroupService: InfluencerGroupsService,
    referenceDataService: ReferenceDataService,
    translate: TranslateService,
    userService: UserService,
    modalService: ModalService,
    router: Router,
    route: ActivatedRoute,
    location: Location,
    pdfViewerService: PdfViewerService,
    eventTracker: EventTrackerService,
    private pdfExportService: PdfExportService,
    private currentRoute: ActivatedRoute,
  ) {
    super(
      measureService,
      campaignService,
      influencerGroupService,
      referenceDataService,
      translate,
      userService,
      modalService,
      router,
      route,
      location,
      pdfViewerService,
      pdfExportService,
      eventTracker
    );
  }


  ngOnInit() {
    // disable highchart animation
    const highcharts = require('highcharts');
    highcharts.setOptions({
      chart: {
        animation: false
      },
      plotOptions: {
        series: {
          animation: false
        }
      }
    });
    super.ngOnInit();

    this.currentRoute.queryParams.subscribe(params => {
      const selectedDateRange = new DateRange();
      selectedDateRange.startDate = params.from;
      selectedDateRange.endDate = params.to;
      this.previousDate = selectedDateRange.formattedStartDate;
      this.currentDate = selectedDateRange.formattedEndDate;
      if (params.orderBy) {
        this.selectedBestPerformingInfluencerOrder = params.orderBy;
        this.reportCriteria.orderBy = params.orderBy;
      }
    });

    this.pdfExportService.triggerIncrementReportReady.subscribe((numberReportReady) => {
      console.log(`ready: ${numberReportReady} - total module: ${this.listModuleForPdf.length}`);
      const totalModule = this.listModuleForPdf.length;

      if (numberReportReady === totalModule) {
        console.log(' ***************************************** ALL REPORT READY TO EXPORT PDF *****************************************');
        setTimeout(() => {
          this.pdfReady();
        }, 200);
      }
    });

  }

  private pdfReady () {
    if (window && typeof (<any>window).pdfReady === 'function') {
      (<any>window).pdfReady();
    }
  }

  public isHiddenSection(section: ReportSectionEnum) {
    const sectionData = Object.getOwnPropertyDescriptor(this.reportData, section);
    const data =  sectionData ? sectionData.value.data : undefined;
    switch (section) {
      case ReportSectionEnum.TIMELINE_REPORT:
      case ReportSectionEnum.LOCAL_AREAS_REPORT:
      case ReportSectionEnum.MENTION_TIMELINE_REPORT:
      case ReportSectionEnum.EXPOSURE_KPI_REPORT:
      case ReportSectionEnum.EXPOSURE_PLATFORM_REPORT:
      case ReportSectionEnum.INSIGHT_BENCHMARK_REPORT:
      case ReportSectionEnum.INSIGHT_OPPORTUNITY_REPORT:
      case ReportSectionEnum.BEST_PERFORMING_INFLUENCER_REPORT:
      case ReportSectionEnum.ROI_REPORT:
        return data && data.length < 1;

      case ReportSectionEnum.BEST_EXPOSURE_REPORT:
        return data && data.bestPerformanceExposures.length < 1 && data.topExposure.length < 1;

      case ReportSectionEnum.SEGMENTATION_INFLUENCER_OVERVIEW_REPORT:
      case ReportSectionEnum.SEGMENTATION_SEGMENT_REPORT:
      case ReportSectionEnum.SEGMENTATION_INDUSTRY_REPORT:
        return data === undefined;

      case ReportSectionEnum.INTERACTION_REPORT:
        return data && data.kpi === undefined && data.posts.length < 1;
      default:
        return false;
    }
  }

  getReportData(section: ReportSectionEnum, sectionIndex) {
    const sectionData = Object.getOwnPropertyDescriptor(this.reportData, section);
    if (!sectionData) {
      return null;
    }
    if (this.specialReports.indexOf(section) < 0) {
      return sectionData ? sectionData.value.data : undefined;
    }

    switch (section) {
      case ReportSectionEnum.ROI_REPORT:
        const roiComponentIndex = this.getReportComponentIndex(section, sectionIndex);
        return Object.assign({}, sectionData.value.data, {
          kpis: roiComponentIndex > 0 ? null : sectionData.value.data.kpis,
          datas: this.getInfluencerRoiList(roiComponentIndex, sectionData.value.data.datas)
        });
      case ReportSectionEnum.OONA_REPORT:
        const oonaComponentIndex = this.getReportComponentIndex(section, sectionIndex);
        const startOonaDataIndex = oonaComponentIndex * CommonConstant.MAX_OONA_ITEM_IN_PDF_PAGE;
        return Object.assign({}, sectionData.value.data, {
          data: sectionData.value.data.data.slice(startOonaDataIndex, startOonaDataIndex + CommonConstant.MAX_OONA_ITEM_IN_PDF_PAGE)
        });
      case ReportSectionEnum.INTERACTION_REPORT:
        const interComponentIndex = this.getReportComponentIndex(section, sectionIndex);
        return Object.assign({}, sectionData.value.data, {
          kpi: interComponentIndex > 0 ? null : sectionData.value.data.kpi,
          posts: this.getInfluencerInteractionList(interComponentIndex, sectionData.value.data.posts)
        });
      case ReportSectionEnum.SEGMENTATION_SEGMENT_REPORT:
          sectionData.value.data.allTopicCharts = sectionData.value.data.allTopicCharts.slice(0, CommonConstant.MAX_OONA_ITEM_IN_PDF_PAGE);
          return sectionData.value.data;
      default:
        return null;
    }
  }

  private getInfluencerRoiList(componentIndex, fullInfluencerList) {
    const limitedInfluencerList = fullInfluencerList.slice(0, this.numberOfPostInRoiPdf);
    if (componentIndex === 0) {
      return limitedInfluencerList.slice(0, CommonConstant.MAX_ROI_ITEM_IN_PDF_PAGE - 2);
    } else {
      const startDataIndex = componentIndex * CommonConstant.MAX_ROI_ITEM_IN_PDF_PAGE - 2;
      return limitedInfluencerList.slice(startDataIndex, startDataIndex + CommonConstant.MAX_ROI_ITEM_IN_PDF_PAGE);
    }
  }

  private getInfluencerInteractionList(componentIndex, fullInfluencerList) {
    if (componentIndex === 0) {
      return fullInfluencerList.slice(0, CommonConstant.MAX_INTERACTION_ITEM_IN_PDF_PAGE - 2);
    } else {
      const startDataIndex = componentIndex * CommonConstant.MAX_INTERACTION_ITEM_IN_PDF_PAGE - 2;
      return fullInfluencerList.slice(startDataIndex, startDataIndex + CommonConstant.MAX_INTERACTION_ITEM_IN_PDF_PAGE);
    }
  }

  getReportComponentIndex(section: ReportSectionEnum, sectionIndex) {
    if (this.specialReports.indexOf(section) < 0) {
      return null;
    }

    switch (section) {
      case ReportSectionEnum.ROI_REPORT:
        const roiComponentIndex = this.roiIndexMapping.get(sectionIndex);
        return roiComponentIndex ? roiComponentIndex : 0;
      case ReportSectionEnum.OONA_REPORT:
        const oonaComponentIndex = this.oonaIndexMapping.get(sectionIndex);
        return oonaComponentIndex ? oonaComponentIndex : 0;
      case ReportSectionEnum.INTERACTION_REPORT:
        const interactionComponentIndex = this.interactionIndexMapping.get(sectionIndex);
        return interactionComponentIndex ? interactionComponentIndex : 0;
      default:
        return null;
    }
  }

  get logoImage() {
    return this.userService.logoImage;
  }

}



// WEBPACK FOOTER //
// ./src/app/main/pdf-viewer/measure-pdf-viewer/measure-pdf-viewer.component.ts